<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="1200px">
    <template v-slot:title>Itinerary Increments</template>
    <v-row v-if="show">
      <v-col>
        <itinerary-increments
          :itinerary="value"
          @iti-updated="$emit('iti-updated')"
        >
        </itinerary-increments>
      </v-col>
    </v-row>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../shared/BasicDialog.vue";
import ItineraryIncrements from "./ItineraryIncrements.vue";
export default {
  name: "ItineraryIncrementsDialog",
  props: {
    value: {
      type: Object,
      default: () => null,
    },
    show: {
      type: Boolean,
      default: () => false,
    },
  },
  components: { BasicDialog, ItineraryIncrements },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/ItineraryIncrementsDialog.vue